/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    Tag,
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
} from './';

/**
 * 
 * @export
 * @interface TagsListResponse
 */
export interface TagsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof TagsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TagsListResponse
     */
    entries: Array<Tag>;
}

export function TagsListResponseFromJSON(json: any): TagsListResponse {
    return TagsListResponseFromJSONTyped(json, false);
}

export function TagsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(TagFromJSON)),
    };
}

export function TagsListResponseToJSON(value?: TagsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(TagToJSON)),
    };
}


